<template>
  <div class="c-form__select">
    <select :class="'c-form__selectinput ' + cssClasses"
            :name="name"
            :required="true"
            :id="'form-element-'+idkey"
            :value="value"
            :disabled="isDisabled"
            @change="$emit('input',$event.target.value)">
      <option v-if="defaultValue !== null" value="" selected>{{ defaultValue }}</option>
      <option v-if="placeHolder" value="" disabled selected hidden>{{ placeHolder }}</option>
      <option v-for="option in options" :value="option" v-if="filter===null">{{ option }}</option>
      <option v-for="option in options" :value="option.id" v-if="filter!==null">{{
          option[filter]
        }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  name: "Select",
  description: "Default dropdown with styling",
  props: {
    name: {
      type: String,
      required: true,
      default: null,
      note: "Define a name that's been used in the default_json of an document"
    },
    idkey: {
      type: Number,
      required: true,
      default: null,
      note: "This is an unique id for adding an id prop to html"
    },
    defaultValue: {
      type: String,
      default: null,
      note: "Dit is a default disabled value and be used as a placeholder"
    },
    options: {type: Array, default: [], note: "Set of options"},
    cssClasses: {type: String, default: null, note: "Extra css classes defined"},
    required: {type: Boolean, default: false},
    value: {
      default: null,
      required: true,
      note: "This is the value that's currently set in this field. Via v-model the value will be automaticly updated."
    },
    filter: {
      type: String,
      default: null,
      note: "Filter to get key in object when options is an array of objects"
    },
    isDisabled: {
      type: Boolean,
      default: false,
      note: 'Disable the functionality to select an option from the dropdwon'
    },
    placeHolder: {required: false, type: String, default: null}
  }
}
</script>
